import { AppBundle } from 'api/optimalprint-sdk.d';
import { AppDispatch, Store } from 'store';
import getProductItem from 'store/product/selector/getProductItem';
import getProductType from 'store/product/selector/getProductType';
import { ProductType } from 'store/product/types';
import getGtmProductsData from '../selector/getGtmProductsData';
import fetchGTMProductsDataOperation from './fetchGTMProductsDataOperation';

const fetchGTMProductDataOperation = () => async (dispatch: AppDispatch, getState: () => Store) => {
  const store = getState();

  const productType = getProductType(store);
  if (productType !== ProductType.predesigned) return;

  const item = getProductItem(store) as AppBundle.Api.Entity.Design.V1.DesignAbstractProduct.DesignProductItem;
  const { encDesignId } = item;
  if (!encDesignId) return;

  const gtmProductsData = getGtmProductsData(store);
  const gtmProductDataFetched = gtmProductsData[encDesignId];
  if (gtmProductDataFetched) return;

  await dispatch(fetchGTMProductsDataOperation([encDesignId]));
};

export default fetchGTMProductDataOperation;
